<template>
  <div>
    <vxe-grid
      ref="refTable"
      :columns="tableColumn"
      :data="tableData"
      :min-height="30"
      :edit-config="tableConfig.editConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :rowConfig="{
        isCurrent: false
      }"
    >
      <template #edit_name="{ row }">
        <el-input v-model="row.name" size="mini" class="flex-1" />
      </template>
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" size="mini" class="flex-1" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" size="mini" class="flex-1" />
      </template>
      <template #edit_counts="{ row }">
        <el-input v-model="row.counts" size="mini" class="flex-1" @blur="calcGoodsAmount(row)" />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input
          v-model="row.goods_price"
          size="mini"
          class="flex-1"
          @blur="calcGoodsAmount(row)"
        />
      </template>
      <template #edit_gongshi="{ row }">
        <el-input v-model="row.gongshi" size="mini" class="flex-1" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" size="mini" class="flex-1" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '工艺名称',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '负责人',
          field: 'fu_ze_ren'
        },
        {
          title: '规格',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '工时',
          field: 'gongshi',
          slots: { edit: 'edit_gongshi' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ],
      tableData: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        let isChange = JSON.stringify(newVal) !== JSON.stringify(oldVal)
        if (isChange) {
          this.$emit('update:data', newVal[0])
        }
      },
      deep: true
    }
  },
  mounted() {
    this.tableData = this.$util.deepCopy([this.data]) || []
  },
  methods: {
    // 计算金额
    calcGoodsAmount(row) {
      let a = row.goods_price || 0
      let b = row.counts || 0
      row.goods_amount = this.$XEUtils.multiply(a, b)
    }
  }
}
</script>

<style scoped>
.table-main {
}
</style>
